import type { ReactElement } from 'react';
import { Badge, makeStyles, tokens } from '@fluentui/react-components';
import {
  CheckmarkCircleRegular,
  DismissCircleRegular,
  WarningRegular,
  InfoRegular,
} from '@fluentui/react-icons';

type BadgeStatus = 'success' | 'warning' | 'error' | 'info';

const STATUS_META: Record<BadgeStatus, { color: 'success' | 'warning' | 'danger' | 'informative'; icon: ReactElement }> = {
  success: { color: 'success', icon: <CheckmarkCircleRegular /> },
  warning: { color: 'warning', icon: <WarningRegular /> },
  error:   { color: 'danger',  icon: <DismissCircleRegular /> },
  info:    { color: 'informative', icon: <InfoRegular /> },
};

const useStyles = makeStyles({
  badge: {
    whiteSpace: 'nowrap',
    flexShrink: 0,
    fontWeight: tokens.fontWeightSemibold,
  },
});

export function StatusBadge({
  status,
  label,
  icon,
}: {
  status: BadgeStatus;
  label?: string;
  icon?: ReactElement;
}) {
  const styles = useStyles();
  const meta = STATUS_META[status];
  return (
    <Badge
      className={styles.badge}
      appearance="tint"
      color={meta.color}
      icon={icon ?? meta.icon}
      size="medium"
    >
      {label || status}
    </Badge>
  );
}
